import React from 'react';
import { createUseStyles } from 'react-jss';

import { IS_DEVELOPMENT } from '../../../constants';
import FacebookButton from './facebook-button';
import GithubButton from './github-button';
import GoogleButton from './google-button';
import TwitterButton from './twitter-button';
// import LoginForm from './login-form';

const useStyles = createUseStyles({
  login: {
    composes: ['flex-rows', 'flex-start', 'px15', 'is-relative'],
  },
});

const LoginViewComponent = React.memo(() => {
  const classes = useStyles();
  return (
    <div className={classes.login}>
      <TwitterButton />
      <GoogleButton />
      <FacebookButton />
      {IS_DEVELOPMENT && <GithubButton />}
      {/* <LoginForm /> */}
    </div>
  );
});

LoginViewComponent.displayName = 'LoginViewComponent';

export default LoginViewComponent;
